import { create } from "zustand";
import { getUserWishlistV2 } from "../hooks/useWishlist";
import { useAuthStore } from "./authStore";

interface WishlistState {
  wishlistedIds: number[];
  isLoading: boolean;
  fetchWishlist: () => Promise<void>;
  refreshWishlist: () => Promise<void>;
  reset: () => void;
}

export const useWishlistStore = create<WishlistState>((set) => ({
  wishlistedIds: [],
  isLoading: false,

  fetchWishlist: async () => {
    const userId = useAuthStore.getState().userId;
    if (!userId) {
      set({ wishlistedIds: [], isLoading: false });
      return;
    }

    try {
      set({ isLoading: true });

      const timeoutPromise = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error("Wishlist fetch timeout")), 5000)
      );

      const fetchPromise = getUserWishlistV2({
        user_id: userId,
        limit: 25,
        offset: 0,
        locale: "en",
      });

      const response = (await Promise.race([
        fetchPromise,
        timeoutPromise,
      ])) as any;

      if (response?.status === "success" && response?.data?.items) {
        set({ wishlistedIds: response.data.items.map((item: any) => item.id) });
      } else {
        set({ wishlistedIds: [] });
      }
    } catch {
      set({ wishlistedIds: [] });
    } finally {
      set({ isLoading: false });
    }
  },

  refreshWishlist: async () => {
    await useWishlistStore.getState().fetchWishlist();
  },

  reset: () => {
    set({ wishlistedIds: [], isLoading: false });
  },
}));
